module.exports = __webpack_public_path__ + "Whatsappicon.777417d.png";